export { ASSETS } from "./assets";
export {
  TRADE_GRID_LAYOUTS,
  TRADE_lAYOUT_COLUMNS,
  TRADE_lAYOUT_BREAKPOINTS,
} from "./layouts";

export const DEFAULT_MARKET_ID =
  "f32054373b8171025f5c10bf6dc101670221ab4b690f8cbafb51bf74ed07ecde";

export const VEGA_GRAPHQL_API = "https://lb.testnet.vega.xyz/query";
export const VEGA_GRAPHQL_WS = "wss://lb.testnet.vega.xyz/query";
